// extracted by mini-css-extract-plugin
export default {"tableTitle":"Billing_tableTitle__i-5d7"};